import * as React from 'react'
import * as BaseControls from '../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import { IDynamicList } from 'library/types/IDynamicList'
import { HttpService } from '..';

interface ISystemContactNumber extends IDynamicList {
    lookupName: string,
}

export default class SystemContactNumber extends SystemBase<ISystemContactNumber>
{
    constructor(props: any) {
        super(props)

    }

    private idField = "DataValue";
    private displayField = "DataText";


    componentDidMount = () => {

        if (this.props.lookupName) {
            HttpService
                .get(`/lookup/lookupname/${this.props.lookupName}`)
                .then(response => {
                    let items: any = [];
                    if (response.data && response.data.length > 0) {
                        response.data.forEach((item: any) => {
                            items.push({ id: item[this.idField], text: item[this.displayField] })
                        })
                        this.setState({ listItems: items });
                    }
                })
                .catch(error => {});
        }
    }
   

    render() {
        const contactDisplayStyle: React.CSSProperties = {
            display: "flex"
        }

        return (
           
            <this.WrapperDiv>
                <div className="inline-inputs"> 
                <BaseControls.Select
                    className="custom-select"
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    name={this.props.name || ''}
                    id={this.props.id || ''}
                    value={this.state.value || ''}
                >
                    {
                        this.state.listItems && this.state.listItems.length > 0 ?
                            this.state.listItems.map((item: any, index: number) => {
                                //return <option key={index} value={item[this.idField]}>{item[this.displayField]}</option>
                                return <option key={index} value={item.id}>{item.text}</option>
                            })
                            : this.props.children
                    }
                </BaseControls.Select>
                <BaseControls.Input
                    type="text"
                    id={this.props.id || ''}
                    value={this.state.value}
                    className="form-control"
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    />
                </div>
                </this.WrapperDiv>
          
        );
    }
}
